import { PropsWithChildren } from "react";

export default function PublicRoute({ children }: PropsWithChildren) {
  return <>{children}</>;
}
